import bfmBusinessImage from './images/bfm.png';
import capitalImage from './images/capital.png';
import france2Image from './images/france-2.svg';
import france3Image from './images/france-3.png';
import france3AlsaceImage from './images/france-3-alsace.svg';
import france3HautsDeFranceImage from './images/france-3-hauts-de-france.svg';
import france3OccitanieImage from './images/france-3-occitanie.png';
import france3PacaImage from './images/france-3-paca.png';
import franceBleuOccitanieImage from './images/france-bleu-occitanie.png';
import franceinfoImage from './images/franceinfo.png';
import jdnImage from './images/jdn.png';
import laDepecheDuMidiImage from './images/la-depeche-du-midi.png';
import laProvenceImage from './images/la-provence.jpg';
import leDauphineLibereImage from './images/le-dauphine-libere.jpg';
import leParisienImage from './images/le-parisien.svg';
import leProgresImage from './images/le-progres.svg';
import lEstRepublicainImage from './images/l-est-republicain.jpg';
import mceImage from './images/mce.png';
import rmcImage from './images/rmc.png';
import tf1Image from './images/tf1.png';
import voixDuMidiImage from './images/voix-du-midi.jpg';

export const linksProps = {
  links: [
    {
      imageUrl: tf1Image,
      imageAltText: 'TF1',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.facebook.com/Swimmy.fr/videos/554765631771808',
      },
      text: "Comme on loue des appartements ou des voitures, vous pouvez louer la piscine d'un particulier qui vit juste à côté de chez vous, un système qui fait recette en ce moment avec la fermeture des bassins municipaux.",
    },
    {
      imageUrl: capitalImage,
      imageAltText: 'CAPITAL',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.facebook.com/1558615417781182/videos/291456482234541',
      },
      text: "Sachez que si vous n'avez pas la chance d'avoir une piscine, aujourd'hui vous avez la possibilité de louer celle d'un particulier via Swimmy. Ca sera la grande tendance de cet été.",
    },
    {
      imageUrl: franceinfoImage,
      imageAltText: 'France info',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.francetvinfo.fr/economie/emploi/metiers/restauration-hotellerie-sports-loisirs/ete-le-succes-des-locations-de-piscines-entre-particuliers_4052079.html',
      },
      text: 'Le propriétaire des lieux, Pierre-Yves, loue sa piscine depuis un an et les réservations coulent à flots. "On rentabilise la piscine" se réjouit-il.',
    },
    {
      imageUrl: france2Image,
      imageAltText: 'France 2',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.france.tv/france-2/journal-20h00/1845945-edition-du-dimanche-26-juillet-2020.html',
      },
      text: "Pour profiter de ces vacances, certains ont opté pour la location d'une piscine ou d'un jardin le temps d'une journée ! La demande explose.",
    },
  ],
};

export const pressPageProps = {
  links: [
    {
      imageUrl: france3PacaImage,
      imageAltText: 'France 3 PACA',
      linkProps: {
        type: 'ExternalLink',
        href: ' https://www.france.tv/france-3/provence-alpes-cote-d-azur/19-20-provence-alpes/1827695-emission-du-mardi-7-juillet-2020.html',
      },
      text: "Au moins, ici, on est tranquille ! On ne va pas à la plage, on n'est pas entouré de plein de personnes, on est bien ! Agréable, il n'y a pas de bruit, on passe une super journée avec les enfants !",
    },
    {
      imageUrl: france3AlsaceImage,
      imageAltText: 'France 3 Alsace',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.facebook.com/1558615417781182/videos/2502401976530002',
      },
      text: `"Et c'est vraiment mieux qu'une piscine municipale ?" "Oui. Déjà, il y a de l'intimité : on n'est qu'entre nous et il y a personne pour nous déranger, nettement mieux !"`,
    },
    {
      imageUrl: lEstRepublicainImage,
      imageAltText: "L'Est Républicain",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.estrepublicain.fr/culture-loisirs/2020/07/28/avec-swimmy-des-particuliers-mettent-leur-piscine-a-disposition',
      },
      text: "Profiter, pour quelques heures ou une journée, de la piscine privée d’un particulier ? Voilà qui est possible via le site internet Swimmy. Dans notre département, ils sont deux propriétaires à proposer leur bassin à la location. Une aubaine pour des baigneurs en quête de fraîcheur… et de tranquillité.",
    },
    {
      imageUrl: franceBleuOccitanieImage,
      imageAltText: "France Bleu Occitanie",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.francebleu.fr/infos/societe/dans-la-region-toulousaine-les-locations-de-piscines-entre-particuliers-ont-la-cote-malgre-le-1591453072',
      },
      text: "Profiter d'une piscine chez un particulier tout un après-midi, le concept séduit de plus en plus dans la région toulousaine. Depuis le 11 mai, date du déconfinement, les demandes de locations de piscines ont explosé et les particuliers ne semblent pas effrayés par le coronavirus.",
    },
    {
      imageUrl: rmcImage,
      imageAltText: "RMC",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://rmc.bfmtv.com/emission/l-explosion-de-la-location-de-piscines-privees-1952604.html',
      },
      text: "J’aime bien le concept parce qu'on ne pense pas souvent à ça. Mais l’été, c’est vraiment pratique quand on habite en ville, qu’on n'a pas forcément de piscine ou d’endroit extérieur à se procurer. C’est vraiment pas mal.",
    },
    {
      imageUrl: voixDuMidiImage,
      imageAltText: "Voix du Midi",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://actu.fr/loisirs-culture/lauragais-malgre-le-coronavirus-il-est-possible-de-louer-la-piscine-d-un-particulier_33925077.html',
      },
      text: "Cette plateforme qui compte 2 200 piscines sur l’ensemble du pays a vu la demande décoller depuis le déconfinement, lundi 11 mai 2020. « C’est multiplié par 10 par rapport à l’an dernier », confie Raphaëlle de Monteynard​, la fondatrice de Swimmy.",
    },
    {
      imageUrl: leParisienImage,
      imageAltText: "Le Parisien",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.leparisien.fr/seine-et-marne-77/location-de-piscine-entre-particuliers-nos-clients-des-parisiens-et-habitants-de-proche-banlieue-13-06-2020-8334879.php',
      },
      text: "Elles avaient loué trois jours chez nous pour aller à Disneyland Paris mais elles ont passé leur temps autour de la pisicne !",
    },
    {
      imageUrl: laProvenceImage,
      imageAltText: "La Provence",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.laprovence.com/article/societe/6038582/boom-des-piscines-les-provencaux-se-jettent-a-leau.html',
      },
      text: "Tout le monde veut anticiper un été passé à la maison dans les meilleures conditions. Swimmy, le nouveau Airbnb de la piscine, vous permet de vous rafraîchir en période de canicule et en toute tranquillité.",
    },
    {
      imageUrl: leProgresImage,
      imageAltText: "Le Progrès",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.leprogres.fr/culture-loisirs/2020/07/09/vague-de-chaleur-a-lyon-pensez-a-louer-une-piscine-rhone',
      },
      text: "La plateforme a multiplié par 10 le nombre de réservations par rapport à 2019 au mois de mai. Le mois de juin semble suivre la même lancée avec la réservation croissante de piscines pour des anniversaires, des enterrements de vie de célibataire, des réunions de famille mais aussi un peu plus de 70 % de réservations de dernière minute en fonction de la météo.",
    },
    {
      imageUrl: france3HautsDeFranceImage,
      imageAltText: "France 3 Hauts de France",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://france3-regions.francetvinfo.fr/hauts-de-france/swimmy-solution-louer-piscine-privee-nord-pas-calais-1523258.html',
      },
      text: `Virginie habite à Caudry, près de Cambrai et elle a découvert par hasard ce Airbnb de la piscine, en regardant un reportage. "Et je me suis dit pourquoi pas", dit-elle simplement.  "Nous l'avons depuis l'année dernière et c'est vrai qu'on ne s'en sert pas tous les jours donc c'est la solution idéale", reprend-elle.`,
    },
    {
      imageUrl: france3OccitanieImage,
      imageAltText: "France 3 Occitanie",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://france3-regions.francetvinfo.fr/occitanie/herault/montpellier/occitanie-soleil-deconfinement-ont-booste-vente-location-piscines-1843456.html',
      },
      text: "Le marché saturé, ne pouvant acheter, certains particuliers se sont tournés vers la location. Sur une plateforme comme Swimmy, jeune start-up française, une famille peut réserver une journée dans la piscine d'un propriétaire qui la met à disposition à partir de 12 à 20 euros par personne.",
    },
    {
      imageUrl: leDauphineLibereImage,
      imageAltText: "Le Dauphiné Libéré",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.ledauphine.com/magazine-immobilier/2020/07/13/louer-un-peu-de-chez-soi-c-est-possible-et-voici-comment',
      },
      text: "Selon la plateforme Swimmy, il est possible de gagner jusqu'à 2 200€ par mois !",
    },
    {
      imageUrl: laDepecheDuMidiImage,
      imageAltText: "La Dépêche du Midi",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.ladepeche.fr/2020/07/05/se-baigner-chez-des-inconnus-8964715.php',
      },
      text: "Le même concept qu'Airbnb, version baignade. Une plateforme qui cartonne en Lot-et Garonne, où les propriétaires de piscines croulent sous les réservations...",
    },
    {
      imageUrl: bfmBusinessImage,
      imageAltText: "BFM Business",
      linkProps: {
        type: 'ExternalLink',
        href: 'https://bfmbusiness.bfmtv.com/mediaplayer/video/raphaelle-de-monteynard-swimmy-swimmy-une-plateforme-de-location-de-piscines-privees-3006-1259003.html',
      },
      text: "Avant il y avait AirBnb, Leboncoin... désormais il y a Swimmy.",
    },
    {
      imageUrl: mceImage,
      imageAltText: 'mceImage',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://mcetv.fr/decouvertes/mon-mag-lifestyle/swimmy-faites-propre-pool-party-paris-grace-airbnb-piscine-1708/',
      },
      text: "Qui ne rêve pas de faire une pool party en région parisienne quand il y a du soleil ?",
    },
    {
      imageUrl: jdnImage,
      imageAltText: 'jdnImage',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.journaldunet.com/patrimoine/art-de-vivre/1197547-ces-start-up-qui-vous-permettent-d-acceder-au-luxe-sans-vous-ruiner/1197835-swimmy',
      },
      text: "Finies les après-midis à la piscine municipale ou à regarder par-dessus la haie du voisin en lui enviant son bassin privé : si vous avez envie de piquer une tête au calme, rendez-vous sur Swimmy.",
    },
  ],
};

export const rentMyPageProps = {
  links: [
    {
      imageUrl: bfmBusinessImage,
      imageAltText: 'BFM business',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.youtube.com/watch?v=3KcorliuNQo&t=224s-',
      },
    },
    {
      imageUrl: leParisienImage,
      imageAltText: 'Le Parisien',
      linkProps: {
        type: 'ExternalLink',
        href:
          'http://www.leparisien.fr/economie/swimmy-le-airbnb-des-piscines-fait-un-carton-14-08-2018-7852812.php',
      },
    },
    {
      imageUrl: france3Image,
      imageAltText: 'France 3',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.youtube.com/watch?v=cP0nZV6hpu4',
      },
    },
    {
      imageUrl: tf1Image,
      imageAltText: 'TF1',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.facebook.com/Swimmy.fr/videos/554765631771808',
      },
    },
    {
      imageUrl: france2Image,
      imageAltText: 'France 2',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.france.tv/france-2/journal-20h00/1845945-edition-du-dimanche-26-juillet-2020.html',
      },
    },
    {
      imageUrl: capitalImage,
      imageAltText: 'CAPITAL',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.facebook.com/1558615417781182/videos/291456482234541',
      },
    },
  ],
};
